import { endpoints } from '../api/sharedEndpoints';
import type { Role, UpdateClubKeyRequest, UserDto, UsersListResponse } from '../api/types';

export interface UsersRepository {
  listUsers(): Promise<UsersListResponse>;
  listUsersByRole(params: { role: Role }): Promise<UsersListResponse>;
  updateUserRole(params: { userId: string; role: Role }): Promise<UserDto>;
  updateCurrentUserClubKey(params: UpdateClubKeyRequest): Promise<UserDto>;
}

export class ApiUsersRepository implements UsersRepository {
  async listUsers(): Promise<UsersListResponse> {
    return endpoints.listUsers();
  }

  async listUsersByRole(params: { role: Role }): Promise<UsersListResponse> {
    return endpoints.listUsersByRole(params.role);
  }

  async updateUserRole(params: { userId: string; role: Role }): Promise<UserDto> {
    return endpoints.updateUserRole(params.userId, params.role);
  }

  async updateCurrentUserClubKey(params: UpdateClubKeyRequest): Promise<UserDto> {
    return endpoints.updateCurrentUserClubKey(params);
  }
}
